<template>
  <div class="liu pos-manage">
    <mt-header fixed :title="title" class="title1">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container">
      <div class="form" style="margin-top: 25px">
        <!-- 费率(万分之) -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>费率</span>
            </div>
            <div class="content">
              <span class="span-text">{{ rateData | formatRateForShow }}&nbsp;&nbsp;万分之</span>
            </div>
          </div>
        </div>
        <!-- 邀请码名称 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>邀请码名称</span>
            </div>
            <div class="content">
              <span class="span-text">{{ qrCodeName }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 邀请码图片 -->
      <div class="qr-code">
        <mt-navbar v-model="activeQrCode">
          <mt-tab-item :id="1">注册二维码</mt-tab-item>
          <mt-tab-item :id="2">进件二维码</mt-tab-item>
        </mt-navbar>
        <mt-tab-container v-model="activeQrCode">
          <mt-tab-container-item :id="1">
            <div class="qr-code-area">
              <div class="qr-code-grid">
                <img :src="require('@/assets/qrcode-no-img.png')" alt="" v-if="!hasQrCodeUrlText" />
                <div ref="qrCodeDiv1" v-if="hasQrCodeUrlText" />
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item :id="2">
            <div class="qr-code-area">
              <div class="qr-code-grid">
                <div ref="qrCodeDiv2" />
              </div>
            </div>
          </mt-tab-container-item>

        </mt-tab-container>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import QRCode from 'qrcodejs2';

export default {
  name: 'PosManageQRCodeShow',
  data() {
    return {
      title: '查看注册邀请码',
      rateData: '', // 费率
      qrCodeName: '', // 名称
      hasQrCodeUrlText: true, // 是否能显示出邀请码
      qrCodeUrl: 'https://www.baidu.com/',
      agentInfo: '',
      productAgentId: '',
      id: '', // 邀请码id
      regLink: '',
      activeQrCode: 1,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.rateData = this.$route.query.fee;
      this.qrCodeName = this.$route.query.name;
      this.agentInfo = this.$route.query.info;
      this.productAgentId = this.$route.query.pId;
      this.id = this.$route.query.id;
      this.regLink = this.$route.query.link;
      this.createQrCodeByFromParam();
    });
  },
  filters: {
    formatRateForShow(val) {
      val = String(val).trim();
      val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
      return parseFloat(val * 10000).toFixed(2);
    },
  },
  methods: {
    onBackBtnClick() {
      this.$router.push({ path: '/posmanagemodule/selfregfeelist' });
    },
    createQrCodeByFromParam() {
      let url = `${this.regLink}?welcomecode=${this.productAgentId}_${this.id}&name=${encodeURIComponent(this.agentInfo)}`;
      new QRCode(this.$refs.qrCodeDiv1, {
        text: decodeURIComponent(url),
        width: 280,
        height: 280,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.L,
      });
      // 2023.2.15 临时改造 访问H5PosManageModule
      url = `${this.regLink.split('?')[0]}?product=${PUBLIC_PRODUCT}#/h5posmanagemodule?welcomecode=1&name=${this.id}`;
      new QRCode(this.$refs.qrCodeDiv2, {
        text: decodeURIComponent(url),
        width: 280,
        height: 280,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.L,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.span-text {
  float: right;
  text-align: right;
  padding-right: 0.6rem !important;
}
.qr-code {
  .mint-tab-item {
    .mint-tab-item-label {
      font-size: 0.85rem !important;
    }
  }
}
</style>
